import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

// pages
import {LoginComponent} from './pages/login/login.component';
import {HomeComponent} from './pages/home/home.component';
import {UsersComponent} from './pages/users/users.component';
import {AuthGuard} from './guards/auth-guard';
import {AccountStatusComponent} from './pages/account-status/account-status.component';
import { SearchInvoicesComponent } from './pages/search-invoices/search-invoices.component';
import { InicioComponent } from './pages/inicio/inicio.component';


const routes: Routes = [


{
path: 'login',
component: LoginComponent

},
{
  path: 'search-invoices',
  component: SearchInvoicesComponent,
  data: { roles: [1, 2] }
},

{
  path: 'home',
  component: HomeComponent,
  children: [
    {
      path: 'inicio',
      component: InicioComponent ,
      canActivate: [ AuthGuard ]

    },
    {
      path: 'users',
      component: UsersComponent ,
      canActivate: [ AuthGuard ],
      data: { roles: [1] }
    },
    
    {
      path: 'account-status',
      component: AccountStatusComponent,
      canActivate: [AuthGuard],
      data: { roles: [1, 2, 3] }
    },
    {
      path: 'search-invoices',
      component: SearchInvoicesComponent,
      canActivate: [AuthGuard],
      data: { roles: [1, 2, 3] }
    },
  

  ],
  //  canActivate: [ AuthGuard ]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: LoginComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts